import { FC, useRef, useEffect, Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useDraggable } from "react-use-draggable-scroll";
import { useAnimation, motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { SectionLayout } from "@/layouts";
import { HomeTitle } from "../../../components/ui";
import { CardMission } from "./card";
import { SectionTitle } from "../home.styles";
import * as Styled from "./mission.styles";

interface Props {
  selecteditem: number;
}

export const MissionScreen: FC<Props> = ({ selecteditem }) => {
  const { t } = useTranslation("global");
  const refScroll = useRef();
  const { events } = useDraggable(refScroll as any);
  const mission = ["missionCar1", "missionCar2", "missionCar3", "missionCar4"];

  const controls = useAnimation();
  const [ref, inView] = useInView();

  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [controls, inView]);

  const variants = {
    hidden: { opacity: 0, y: 100 },

    visible: ({ delay }: { delay: number }) => ({
      opacity: 1,
      transition: {
        delay,
        duration: 2,
      },
      y: 0,
    }),
  };

  return (
    <SectionLayout id="mission" className="animate__animated animate__fadeIn">
      <Styled.MissionContainer>
        <Styled.TextMissionContainer>
          <HomeTitle
            mb="0.625rem"
            className="headline-small weight-medium"
            color={selecteditem === 2 ? "var(--primary-light)" : "var(--primary-dark)"}
            borderColor={selecteditem === 2 ? "var(--primary-light)" : "var(--primary-dark)"}
          >
            {t("MissionScreen.title")}
          </HomeTitle>
          <SectionTitle className="display-large" color={selecteditem === 2 ? "var(--on-surface-light)" : "var(--on-surface-dark)"}>
            {t("MissionScreen.description")}
            <span className="weight-medium">{t("MissionScreen.descriptionBold")}</span>
          </SectionTitle>
        </Styled.TextMissionContainer>
        <div ref={ref}>
          <Styled.CardContainer {...events} ref={refScroll}>
            {mission.map((item, index) => (
              <motion.div key={index} variants={variants} initial="hidden" animate={controls} custom={{ delay: index * 0.3 }}>
                <CardMission idx={index} cardInfo={item} selecteditem={selecteditem} key={index} />
              </motion.div>
            ))}
          </Styled.CardContainer>
        </div>
      </Styled.MissionContainer>
    </SectionLayout>
  );
};
